import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { WancomHttpService } from './services/wancom-http/wancom-http.service';

@Component({
    selector: 'wnvw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title = 'wnvw';

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private http: WancomHttpService
    ) {
        this.http.connectSignalR();

        this.matIconRegistry.addSvgIcon(
            'wancomText',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/wancomText.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'editSpotTemplate',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/editSpotTemplateIcon.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'createSpotBig',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/createSpotBig.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'customSpotBadge',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/customSpotBadge.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'logoWanview',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/logo_wanview.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'logoWanviewBlack',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/logo_wanview_black.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'cover',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/cover.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'contain',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/contain.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'extend',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/extend.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'logoWanviewWhite',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/logo_wanview_white.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'videoProcessing',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/settingcustom.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'specifiedFormatImport',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/specifiedFormatImport.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'multiFormatImport',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/multiFormatImport.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'textTemplate',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/textTemplate.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'videoImport',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/videoImport.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'videoEdit2',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/videoEdit2.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'videoEdit',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/videoEdit.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'mediaImport',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/mediaImport.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'target',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/cible.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'mediaLibrary',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/mediaLibrary.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'spotLibrary',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/spotLibrary.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_broadcast',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_broadcast.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_luminosity',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_luminosity.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_completelyoff',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_completelyoff.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_partiallyoff',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_partiallyoff.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_other',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_other.svg'
            )
        );

        //Icones pour page de login

        matIconRegistry.addSvgIcon(
            'google_Icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/login_icons/google-icon.svg'
            )
        );

        matIconRegistry.addSvgIcon(
            'facebook_Icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/login_icons/facebook-icon_secondary.svg'
            )
        );

        matIconRegistry.addSvgIcon(
            'twitter_Icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/login_icons/twitter-icon.svg'
            )
        );

        matIconRegistry.addSvgIcon(
            'microsoft_Icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/login_icons/microsoft_icon.svg'
            )
        );

        matIconRegistry.addSvgIcon(
            'locationDistance',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/locationDistance.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'store-indoor',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/store-indoor.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'crossedBlueMarker',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/crossedblueMarker.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'crossedPinkMarker',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/crossedpinkMarker.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'manyBlueMarker',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/manyblueMarker.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'manyPinkMarker',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/manypinkMarker.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'store-outdoor',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/store-outdoor.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'ticket_other',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/ticket_other.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'generativeIA',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/generativeIA.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'robot',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/lottie-robot.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'stripe',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../assets/stripeIcon.svg'
            )
        );
    }
}
